import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import svg from "./svg_bg";

createApp(App).use(store).use(svg).mount("#portfolio");
